<template>
  <div class="data-pages dataList">
    <div class="p16">
      <p style="font-weight: bold;">会员卡交易数据<span class="moneys fontSize14">（数据指标可能存在几分钟延迟）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs mb10 br10">
            <div class="titles">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>交易汇总</i></p>
              <v-date @time="change" class="ml10"></v-date>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="5">
                <p class="van-text text">会员充值</p>
                <p class="van-label f16">{{amount.rechargeAmount}}</p>
              </el-col>
              <el-col class="cols" :span="5">
                <p class="van-text text">提现金额</p>
                <p class="van-label f16">{{amount.withdrawAmount}}</p>
              </el-col>
              <el-col class="cols" :span="5">
                <p class="van-text text">冻结差额</p>
                <p class="van-label f16">{{amount.freezeAmountDiff}}</p>
              </el-col>
              <el-col class="cols" :span="5">
                <p class="van-text text">产品服务消费</p>
                <p class="van-label f16">{{amount.serveProductConsumeAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text text">产品服务退款</p>
                <p class="van-label f16">{{amount.serveProductRefundAchAmount}}</p>
              </el-col>
            </el-row>
            <el-row class="rows">
               <el-col class="cols" :span="5">
                <p class="van-text text">充值赠送</p>
                <p class="van-label f16">{{amount.rechargeGiveAmount}}</p>
              </el-col>
              <el-col class="cols" :span="5">
                <p class="van-text text">赠金提现</p>
                <p class="van-label f16">{{amount.withdrawGiveAmount}}</p>
              </el-col>
              <el-col class="cols" :span="5">
                <p class="van-text text">赠金冻结差额</p>
                <p class="van-label f16">{{amount.freezeGiveAmountDiff}}</p>
              </el-col>
            </el-row>
          </div>
          <div class="boxs br10">
            <div class="align-items pr16" @click="lookList">
              <div class="titles">
                <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>交易明细</i></p>
                <el-select v-model="query.tradeType" @change="selectChange" class="select ml10" placeholder="交易类型">
                  <el-option v-for="(item,index) in tradeTypeList" :key="index" :label="item.text" :value="item.value"></el-option>
                </el-select>
              </div>
              <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16" v-show="listFlag">
              <el-table :data="list" :max-height="height - 430" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="tradeTypeCn" label="交易类型"></el-table-column>
                <el-table-column prop="amount" label="金额"></el-table-column>
                <el-table-column prop="oxCname" label="操作人"></el-table-column>
                <el-table-column label="订单时间" width="170px">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
                </el-table-column>
              </el-table>
              <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      dataUrl: require("../../../assets/images/home/data.png"),
      amount: {
        itemName: "",
        itemNum: "",
        saleAmount: "", //销售业绩
        saleDeductAmount: "",
        workAmount: "", //劳动
        workDeductAmount: ""
      },
      list: [],
      tradeTypeList: [
        {
          text: "全部类型",
          value: "",
          imgShow: true
        },
        {
          text: "充值",
          value: "recharge",
          imgShow: false
        },
        {
          text: "消费",
          value: "consume",
          imgShow: false
        },
        {
          text: "退款",
          value: "refund",
          imgShow: false
        },
        {
          text: "提现",
          value: "withdraw",
          imgShow: false
        },
        {
          text: "作废",
          value: "invalid",
          imgShow: false
        }
      ],
      url: this.$url.memberFundFlow.list,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        tradeType: ""
      },
      listFlag: false,
      height: this.$store.getters.MainHeight,
      totalCount: 0
    };
  },
  components: {},
  created() {
    // this.init();
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.list = [];
      this.listFlag = false;
      this.init();
    },
    selectChange(org) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.tradeType = org;
      this.list = [];
      this.init();
      this.totalCounts();
    },
    init () {
      this.$api.post(this.$url.memberFundFlow.summary, {
          beginTime: this.query.beginTime,
          endTime: this.query.endTime
        }).then(res => {
          if (res) {
            this.amount = res;
            // console.log(res,66666);
          }
        });
    },
    lookList () {
      // 查看列表
      if (!this.listFlag) {
        this.totalCounts();
        this.listFlag = true;
      }
    },
    totalCounts () {
      this.$api.post(this.$url.memberFundFlow.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
}
.boxs {
  background: #fff;
  .titles {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
</style>